import ko from 'knockout';
import $ from 'rgs-jquery';

ko.bindingHandlers.tableSorting = {
	init (element, valueAccessor) {
		const { enabled, sortBy } = valueAccessor();
		const $element = $(element);
		if (enabled) {
			$element.on('click', event => {
				const sortTerm = $(event.target)
					.parentsUntil($(event.currentTarget), '[data-table-sorting-term]')
					.attr('data-table-sorting-term');

				if (sortTerm) {
					sortBy(sortTerm);
				}
			});
		}
		ko.utils.domNodeDisposal.addDisposeCallback(element, () => $element.off());
	},
};